import BnkCatalogue from '@/pages/bnk-catalogue/BnkCatalogue';
import i18n from '../../translations/i18n';
import initApp from '../../util/init-app';

initApp({
  isPublic: true,
  i18n,
  render: (h) => h(BnkCatalogue),
});
